import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-categories-list',
  templateUrl: './all-categories-list.component.html',
  styleUrls: ['./all-categories-list.component.scss']
})
export class AllCategoriesListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
